<div
  [class]="class + ' position-relative'"
  [class.cml-8]="arrow === 'left'"
  [class.cmr-8]="arrow === 'right'"
  [class.cpt-8]="arrow?.includes('top')"
  [class.cpb-8]="arrow?.includes('bottom')"
>
  <div [ngClass]="{ wrap: wrapText }" class="custom-tip">
    <em class="material-icons" *ngIf="error">info</em>
    <span
      *ngIf="!showTemplate"
      class="custom-tip-text"
      [ngClass]="{ 'create-new-line': createNewLine }"
      [style]="textStyle"
    >
      {{ text | translate }}
      <ng-content></ng-content>
      <a *ngIf="link" href="{{ link?.href }}"> {{ link?.text }}</a>
    </span>
    <ng-content *ngIf="showTemplate"></ng-content>
  </div>

  <div
    *ngIf="arrow === 'left'"
    class="custom-left-tip-after tooltip-arrow"
    [style]="tipStyle"
  ></div>
  <div
    *ngIf="arrow === 'right'"
    class="custom-right-tip-after tooltip-arrow"
    [style]="tipStyle"
  ></div>
  <div *ngIf="arrow === 'top'" class="custom-top-tip-after tooltip-arrow" [style]="tipStyle"></div>
  <div
    *ngIf="arrow === 'bottom'"
    class="custom-bottom-tip-after tooltip-arrow"
    [style]="tipStyle"
  ></div>
  <div
    *ngIf="arrow === 'bottom-right'"
    class="custom-bottom-right-tip-after tooltip-arrow"
    [style]="tipStyle"
  ></div>
  <div
    *ngIf="arrow === 'top-right'"
    class="custom-top-right-tip-after tooltip-arrow"
    [style]="tipStyle"
  ></div>
</div>
